export const FirebaseConfig = {
	"projectId": "pickmi-ng-project",
	"appId": "1:670060175333:web:5c94f03bc4d027d35b590c",
	"databaseURL": "https://pickmi-ng-project-default-rtdb.firebaseio.com",
	"storageBucket": "pickmi-ng-project.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyDVq0LVzBFapHw5sd7XFH8sNsTjGYFU_ck",
	"authDomain": "pickmi-ng-project.firebaseapp.com",
	"messagingSenderId": "670060175333",
	"measurementId": "G-Y5PX0MKMLT"
};